module.exports = __webpack_public_path__ + "static/media/Card_Topical.7c22466f.svg";